/**
 * Created by pskwira on 24.04.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../core/cookies', '../store/favouriteStore'], function($, _, EventEmitter, CookiesHelper, FavouriteStore ){

    var leadConfig = {
        btnMapSelector: '#leadProcesEmailSummary',
        terminOverlay: '#terminOverlay',
        btnToolSelector: '#terminStep',
        contentSelector: '.overlay-termin-content',
        contentMapSelector: '.termin-map',
        contentToolSelector: '.termin--tool',
        contentFormSelector: '.termin-lead-form',
        overlayHeader: '.default--overlay--header'
    }

    function LeadProcess(){}

    LeadProcess.prototype = _.clone(EventEmitter.prototype);

    LeadProcess.prototype.init = function(){

        var _this = this;

        this.favouritesStore = new FavouriteStore();

        this.bindEvents();

    };

    LeadProcess.prototype.bindEvents = function(){

        var _this = this;

        window.addEventListener('thankYouPageShow', function(){
            $(leadConfig.terminOverlay).addClass('thankyou--step');
        })

        window.addEventListener('thankYouPageHide', function(){
            $(leadConfig.terminOverlay).removeClass('thankyou--step');
            _this.emit('terminLeadFormReloaded');
        })

        $(document).on({
            click: function(e){
                e.preventDefault();
                _this.goToFormStep();
            }
        }, '#terminStep');

        $(document).on({
            click: function(e){
                e.preventDefault();
                _this.goToInitalStep();
            }
        }, '#backToInitialStep');

        $(document).on({
            click: function(e){
                e.preventDefault();
                e.stopPropagation();
                _this.backToInitalStep();
                $('.overlay__header__close__calculator').click();
            }
        }, '#backToFavourites');

        $(document).on({
            click: function(e){
                e.preventDefault();
                _this.goToInitalStep();
            }
        }, '.overlay__header__close__calculator');

    };

    LeadProcess.prototype.goToInitalStep = function(){
        $(leadConfig.overlayHeader).show();
        $(leadConfig.terminOverlay).removeClass('offer--step');
        $(leadConfig.terminOverlay).addClass('initial--step');

    }

    LeadProcess.prototype.goToFormStep = function(){
        $(leadConfig.overlayHeader).hide();
        $(leadConfig.terminOverlay).removeClass('initial--step');
        $(leadConfig.terminOverlay).addClass('offer--step');
    }

    LeadProcess.prototype.goToThankYou = function(){
        $(leadConfig.terminOverlay).addClass('thankyou--step');
    }

    LeadProcess.prototype.switchContent = function(selector){

        var _this = this;

        $(leadConfig.contentSelector).hide();
        $(selector).show();

    }

    LeadProcess.prototype.updateFormFavValuesAfterSubmit = function(){

        var _this = this;

        var favourites = _this.favouritesStore.getFavourites();

        setTimeout(function(){
            $('#terminOverlay').find("input[id$='favourite-id']").val(favourites.general.code);
            $('#terminOverlay').find("input[id$='favourite-value']").val(JSON.stringify(favourites));

        }, 5000);

    }

    return LeadProcess;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/leadProcess/leadProcess.js